import { Button, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import {
  addToCart,
  addToCartLocal,
  deleteCartItem,
  getCartItems,
  toggleSignUp,
  updateCart,
  updateCartLocal,
  getCartItemsLocal,
  deleteCartItemLocal,
  pushEvent
} from '../../../store/actions/user/User';
import { saveEventData } from "../../../utils/events-handler"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactPixel from 'react-facebook-pixel';


const useStyles = makeStyles((theme) => ({
  itemCard: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: '1rem',
    height: '300px',
    width: '200px',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '180px'
    }
  },
  itemImage: {
    width: '150px',
    height: '125px',
    margin: '0 20px'
  },
  itemTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
    }
  },
  itemDescription: {
    fontSize: '12px',
    textAlign: 'left',
    overflow: 'hidden',
    paddingTop: '0.25rem',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    }
  },
  itemAction: {
    display: 'flex',
    justifyContent: 'space-around',
    paddingTop: '0.5rem',
    alignItems: 'center'
  },
  price: {
    paddingRight: '5px',
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '15px',
  },
  priceOffer: {
    textAlign: 'left',
    fontSize: '9px',
    fontWeight: 'bold'
  },
  addToCart: {
    width: '75px',
    height: '30px',
    background: 'rgb(1, 160, 90)',
    border: '1px solid rgb(1, 160, 90)',
    color: '#fff',
    borderRadius: '15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    userSelect: 'none',
    '&:hover': {
      boxShadow: '1px 1px 2px #000000'
    }
  },
  addToCartBtn: {
    width: '75px',
    height: '30px',
    background: 'rgb(1, 160, 90)',
    border: '1px solid rgb(1, 160, 90)',
    color: '#fff',
    borderRadius: '15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '0 5px',
    userSelect: 'none',

  },
  unavailableCart: {
    fontSize: '14px'
  },
  add: {
  },
  qty: {
    color: 'white',
    fontSize: '14px'
  }
}));

const Item = ({
  id,
  image,
  vendor,
  title,
  description,
  vendorId,
  price,
  product,
  isMenu,
  auth,
  viewMore,
  toggleSignUp,
  getCartItems,
  addToCart,
  updateCart,
  updateCartLocal,
  deleteCartItem,
  deleteCartItemLocal,
  addToCartLocal,
  cart,
  closed,
  pushEvent,
  isOffer
}) => {
  const classes = useStyles();
  const [quantity, updateQuantity] = useState(0);
  useEffect(() => {
    if (cart?.length) {
      if (isMenu) {
        const cartItem = cart?.find((item) => item.menuId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }
      } else {
        const cartItem = cart?.find((item) => item.productId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }
      }
    }
  }, [product]);

  useEffect(() => {
    if (cart?.length) {
      if (isMenu) {
        const cartItem = cart?.find((item) => item.menuId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }
      } else {
        const cartItem = cart?.find((item) => item.productId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }else{
          updateQuantity(0);
        }
      }
    }
  }, []);


  useEffect(() => {
    if (cart?.length) {
      if (isMenu) {
        const cartItem = cart?.find((item) => item.menuId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }
      } else {
        const cartItem = cart?.find((item) => item.productId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }else{
          updateQuantity(0);
        }
      }
    } else {
      updateQuantity(0);
    }
  }, [JSON.stringify(cart), cart?.length]);

  const removeFromCart = () => {
    if (auth) {
      if (isMenu) {
        const cartPayload = cart?.find((item) => item.menuId === id);
        if (quantity === 1) {
          deleteCartItem(cartPayload?.id).then((data) => {
            if (data) {
              getCartItems();
            }
          });
        } else {
          updateCart({ cartId: cartPayload.id, quantity: quantity - 1 }).then(
            (data) => {
              if (data) {
                getCartItems();
              }
            }
          );
        }
      } else {
        const cartPayload = cart?.find((item) => item.productId === id);
        if (quantity === 1) {
          deleteCartItem(cartPayload?.id).then((data) => {
            if (data) {
              getCartItems();
            }
          });
        } else {
          updateCart({ cartId: cartPayload.id, quantity: quantity - 1 }).then(
            (data) => {
              if (data) {
                getCartItems();
              }
            }
          );
        }
      }
    } else {
      const key = isMenu ? 'menuId' : 'productId'
      var cartPayload = cart?.find((item) => item[key] === id);
      if (quantity === 1) {
        deleteCartItemLocal(cartPayload, key);
      } else {
        cartPayload.quantity = quantity - 1
        updateCartLocal(cartPayload, key);
      }
      getCartItemsLocal();
    }
    updateQuantity(quantity - 1);
  };

  const addCart = () => {
    const payload = {
      vendorId: vendorId,
      quantityType: '1',
      quantity: 1,
      productId: '',
      menuId: ''
    };
    if (isMenu) {
      payload.menuId = id;
    } else {
      payload.productId = id;
    }
    saveEventData(pushEvent, product.name+"AddedToCart")
    if (auth) {
      addToCart(payload).then((data) => {
        if (data) {
          getCartItems();
          updateQuantity(quantity + 1);
        }
      });
    } else {
      payload.products = [product]
      addToCartLocal(payload, vendor);
      getCartItemsLocal();
      updateQuantity(quantity + 1);
    }
    const options = {
      autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
      debug: false, // enable logs
    };
    // ReactPixel.init('831925394401262', {}, options);
    // ReactPixel.track('AddToCart');
  };

  const updateToCart = () => {
    if (auth) {
      if (isMenu) {
        const cartPayload = cart?.find((item) => item.menuId === id);
        if (cartPayload) {
          updateCart({ cartId: cartPayload.id, quantity: quantity + 1 }).then(
            (data) => {
              if (data) {
                getCartItems();
              }
            }
          );
        }
      } else {
        const cartPayload = cart?.find((item) => item.productId === id);
        if (cartPayload) {
          updateCart({ cartId: cartPayload.id, quantity: quantity + 1 }).then(
            (data) => {
              if (data) {
                getCartItems();
              }
            }
          );
        }
      }
    } else {
      const key = isMenu ? 'menuId' : 'productId'
      var cartPayload = cart?.find((item) => item[key] === id);
      cartPayload.quantity = quantity + 1
      updateCartLocal(cartPayload, key);
      getCartItemsLocal();
    }
    updateQuantity(quantity + 1);
  };

  const renderPixel = (product, vendorId) => {
    return (
      <>
        <MetaTags>
          <meta property="og:title" content={product.name} />
          <meta property="og:description" content={product.description} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:image" content={product.image} />
          <meta property="product:brand" content="Grospick" />
          <meta property="product:availability" content="in stock" />
          <meta property="product:condition" content="new" />
          <meta property="product:price:amount" content={product.price} />
          <meta property="product:sale_price:amount" content={product.offerPrice} />
          <meta property="product:price:currency" content="AUD" />
          <meta property="product:retailer_item_id" content={product.id} />
          <meta property="product:item_group_id" content={vendorId}></meta>
        </MetaTags>
        <div itemscope itemtype="http://schema.org/Product">
          <meta itemprop="brand" content="Grospick" />
          <meta itemprop="name" content={product.name} />
          <meta itemprop="description" content={product.description} />
          <meta itemprop="productID" content={product.id} />
          <meta itemprop="url" content={window.location.href} />
          <meta itemprop="image" content={product.image} />
          <div itemprop="value" itemscope itemtype="http://schema.org/PropertyValue">
            <span itemprop="propertyID" content={vendorId}></span>
            <meta itemprop="value" content={product.name}></meta>
          </div>
          <div itemprop="offers" itemscope itemtype="http://schema.org/Offer">
            <link itemprop="availability" href="http://schema.org/InStock" />
            <link itemprop="itemCondition" href="http://schema.org/NewCondition" />
            <meta itemprop="price" content={product.offerPrice} />
            <meta itemprop="priceCurrency" content="AUD" />
          </div>
        </div>
      </>
    )
  }

  //   const updateLocalCart = () => {
  //     const tempCartItems = [...cart];
  //     const individualCart = tempCartItems?.findIndex((item) => {
  //       if (isMenu) {
  //         return item.menuId === id;
  //       } else {
  //         return item.productId === id;
  //       }
  //     });
  //     const cartPayload = {
  //       menuId: tempCartItems[individualCart]?.menuid || '',
  //       productId: tempCartItems[individualCart]?.productId || '',
  //       quantity: tempCartItems[individualCart].quantity + 1,
  //       products: []
  //     };
  //     if (individualCart !== -1) {
  //       cartPayload.products.push({price: price });
  //       tempCartItems[individualCart] = cartPayload;
  //     } else {
  //       tempCartItems.push(cartPayload);
  //     }
  //     addToCartLocal(tempCartItems);
  //   };

  return (
    <div className={classes.itemCard} style={viewMore ? { width: '100%' } : {}}>
      {/* {product.isOffer && renderPixel(product, vendorId)} */}
      <div className={classes.itemImage} style={image ? {
      } : {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#E0E0E0'
        }}>
        {image ? <LazyLoadImage
          height="100%"
          src={
            image
          }
          effect="blur"
          alt={title}
        />
          :
          <span style={{ color: 'white' }}><b>No Image</b></span>
        }
      </div>
      <div>
        <div className={classes.itemTitle}>{title}</div>
        <div title={description} className={classes.itemDescription}>{description}</div>
        <div className={classes.itemAction}>
          <div className={classes.price} style={product.isOffer ? { paddingRight: '0px' } : {}}>{product.isOffer ? product.offerPrice : price} AUD</div>
          {product.isOffer && <del><div className={classes.priceOffer}>{price} AUD</div></del>}
          {product.quantity == 0 || closed ?

            <div className={classes.unavailableCart}>
              {closed ? 'Closed' : 'Unavailable'}
            </div>
            :
            <div className={classes.addToCart}>
              {quantity === 0 ? (
                <div className={classes.add} onClick={addCart}>
                  + ADD
                </div>
              ) : (
                  <>
                    <div className={classes.minus} onClick={removeFromCart}>
                      -
                </div>
                    <div className={classes.qty}>{product.isGm || product.isMl ? quantity / 10 : quantity} {product.isGm ? 'KG' : (product.isMl ? 'L' : 'Qty')}</div>
                    <div className={classes.plus} onClick={updateToCart}>
                      +
                </div>
                  </>
                )}
            </div>
          }
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.user.auth,
  cart: state.user.cart
});

const mapDispatchToProps = (dispatch) => ({
  toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
  addToCart: (product) => dispatch(addToCart(product)),
  addToCartLocal: (product, vendor) => dispatch(addToCartLocal(product, vendor)),
  updateCart: (product) => dispatch(updateCart(product)),
  updateCartLocal: (product, key) => dispatch(updateCartLocal(product, key)),
  getCartItems: () => dispatch(getCartItems()),
  getCartItemsLocal: () => dispatch(getCartItemsLocal()),
  //   emptyCart: () => dispatch(emptyCart()),
  pushEvent: (details) => dispatch(pushEvent(details)),
  deleteCartItem: (cartId) => dispatch(deleteCartItem(cartId)),
  deleteCartItemLocal: (cartId, key) => dispatch(deleteCartItemLocal(cartId, key))
});

export default connect(mapStateToProps, mapDispatchToProps)(Item);
